// extracted by mini-css-extract-plugin
export default {"container":"CampaignRestrictionsModeEdit_container__llh2v","wrapperInput":"CampaignRestrictionsModeEdit_wrapperInput__vX9PG"};